export function createHttpRequestFetchString(
  url: string,
  method: 'GET' | 'POST',
  bodyObject: object,
): string {
  const bodyJson = JSON.stringify(JSON.stringify(bodyObject));

  const headers = {
    accept: 'application/json, text/plain, */*',
    'accept-language': 'en-US',
    'content-type': 'application/json',
  };
  const headersJson = JSON.stringify(headers);
  const fetchString = `fetch("${url}", { "headers": ${headersJson}, "body": ${bodyJson}, "method": "${method}" });`;
  return fetchString;
}
